export default {
    colorDark: '#7C3AED',   
    colorMediumDark: '#A74EC2',   
    colorMediumLight: '#D76292',   
    colorLight: '#F87171',   
}